<template>

  <div>
    <div class="flex md12 xs12">
      <div v-if="!isLoading && model != null">

        <vuestic-widget :headerText="model.title">

          <vuetable
            :apiMode="apiMode"
            :fields="fields"
            :itemsPerPage="itemsPerPage"
            :defaultPerPage="defaultTablePerPage"
            clickable
            :data="data"
            :queryParams="queryParams"
            :initialPage="initialPage"
            :dataProvider="dataProvider"
          >
            <template slot="dateSlot" scope="props">
              <div class="date-cell">

                <date-cell
                  name="date"
                  :rowData="props.rowData"
                  :onChange="onChange"
                />

              </div>
            </template>

            <template slot="textSlot" scope="props">
              <div class="text-cell">

                <text-cell
                  name="title"
                  :rowData="props.rowData"
                  :onChange="onChange"
                />

              </div>
            </template>

            <template slot="isPrintedSlot" scope="props">
              <div class="checkbox-cell">

                <checkbox-cell
                  name="print"
                  :initialValue="!!props.rowData.isPrinted"
                  :rowData="props.rowData"
                  :onChange="onChange"
                />

              </div>
            </template>

            <template slot="hasOriginalSlot" scope="props">

              <div class="checkbox-cell">

                <checkbox-cell
                  name="original"
                  :initialValue="!!props.rowData.hasOriginal"
                  :rowData="props.rowData"
                  :onChange="onChange"
                />

              </div>
            </template>

            Loading
          </vuetable>
        </vuestic-widget>

      </div>
    </div>
    <div class="flex md12 align--center justify--center">
      <div class="pre-loader-container">

        <vuestic-pre-loader v-show="isLoading"
                            class="pre-loader"></vuestic-pre-loader>

        <div v-if="!isLoading && error != null">
          {{$t( this.error) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TextCell from './TextCell'
import DateCell from './DateCell'
import { companiesApi } from '../../../services/api/companiesApi'
import ItemsPerPageDef
  from '../../../vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition'
import QueryParams from '../../../vuestic-theme/vuestic-components/vuestic-datatable/data/query-params'
import Vue from 'vue'
import Vuetable from 'vuetable-2'
import CheckboxCell from './CheckboxCell'
import { Debounce } from './utils'
import { documentsApi } from '../../../services/api/documentsApi'

Vue.component('date-cell', DateCell)
Vue.component('text-cell', TextCell)
Vue.component('checkbox-cell', CheckboxCell)

let fields = [
  {
    name: '__slot:dateSlot',
    title: 'Дата', // TODO localize
    width: '35%',
  },

  {
    name: 'title',
    dataClass: 'text-left',
    title: 'Име на клиент' // TODO localize
  },

  {
    name: '__slot:isPrintedSlot',
    title: 'Отбележи като принтиран'
  },

  {
    name: '__slot:hasOriginalSlot',
    title: 'Донесен оригинал'
  }
]

export default {
  components: { CheckboxCell, Vuetable },
  name: 'company-details',

  data () {
    return {

      apiMode: false,
      fields: fields,
      data: [],
      itemsPerPage: ItemsPerPageDef.itemsPerPage,
      defaultTablePerPage: 6,
      paginationPath: '',
      initialPage: 1,
      queryParams: QueryParams,

      model: {},
      documents: {},

      error: null,

      isLoading: true,
    }
  },

  mounted: async function () {
    const companyId = this.$route.params.companyId

    const companyRes = await companiesApi.get(companyId)
    const companyDocumentsRes = await companiesApi.getDocuments(companyId)

    this.isLoading = false

    const result = this.mergeResults(companyRes, companyDocumentsRes)

    if (result == null) {
      this.error = 'Errors.server'

      return
    }

    this.data = result.documents
    this.model = result
    this.documents = companyDocumentsRes.data.documents.reduce((acc, val) => {
      acc[val.id] = val

      return acc
    }, {})

    this.debouncer = new Debounce(1000)
  },

  methods: {
    onLoaded: () => {

    },

    mergeResults: function (companiesRes, documentsRes) {
      if (!companiesRes.data.success) return null
      if (!documentsRes.data.success) return null

      return {
        ...companiesRes.data.company,
        documents: documentsRes.data.documents.map((item) => {
          return {
            ...item,
            documentDate: new Date(item.documentDate)
          }
        })
      }
    },

    dataProvider: function (pagination) {
      return this.data
    },

    onChange: function (data) {
      let document = this.documents[data.id]
      let payload = {
        companyId: document.parent,
        docId: document.id,
        attribute: data.name,
        value: data.value
      }

      this.debouncer.run(() => {
        this.saveDocument(payload)
      })
    },

    saveDocument: async function (data) {
      documentsApi.update(data)
    }
  }
}
</script>

<style scoped>

  .checkbox-cell {
    text-align: right;
  }

</style>
